import CardItemGroup from 'components/card-item-group/card-item-group';

export default CardItemGroup;
